import { Heading as ChakraHeading } from '@chakra-ui/react'

export const Heading = ChakraHeading
